import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { EDealType, EOfferType } from 'shared/repositories/cpd/entities/offer_data/OfferData';
import {
  fetchIsSuitableOffersForCpd,
  TIsSuitableOffersForCpdResponse,
} from 'shared/repositories/cpd/v1/is-suitable-offers-for-cpd';
import { addressSelector, selectDealType, selectOfferId, selectOfferPriceRub, selectOfferType } from 'shared/selectors';
import { IThunkActionCreator } from 'shared/store';

import { setAvailableCpd } from './';

export const getIsCpdAvailable = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  try {
    const state = getState();
    const price = selectOfferPriceRub(state);
    const offerId = selectOfferId(state);
    const dealType = selectDealType(state);
    const offerType = selectOfferType(state);
    const address = addressSelector(state);
    const addressString = address.map(addr => addr.fullName).join(', ');

    const res = (await fetchIsSuitableOffersForCpd({
      httpApi: context.httpApi,
      parameters: {
        data: [
          {
            address: addressString,
            dealType: dealType as unknown as EDealType,
            offerType: offerType as unknown as EOfferType,
            price,
            offerId,
          },
        ],
      },
    })) as TIsSuitableOffersForCpdResponse;

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: res.statusCode,
        domain: 'getIsCpdAvailable.ts',
        message: res.response.message as string,
      });
    }

    dispatch(setAvailableCpd(res.response.response[0]));
  } catch (e) {
    context.logger.error(e);

    dispatch(setAvailableCpd(false));
  }
};
